import { MutationTree } from 'vuex';
import { AwsServiceState } from '@/store/modules/cloud/aws/aws.store';
import {
  FILTER_SERVICES_ON_INSTALLATION_TYPE_CHANGE,
  SET_TOGGLE_MONITORING,
  UPDATE_SERVICE_INFO,
  UPDATE_SERVICES_AFTER_INSTALL,
} from '@/store/modules/cloud/aws/aws.constants';

const awsServiceMutation: MutationTree<AwsServiceState> = {

  [UPDATE_SERVICES_AFTER_INSTALL](state, serviceSlug) {
    state.installedSlugs.push(serviceSlug);
    state.allServices = state.allServices.map((service) => {
      if (service.slug === serviceSlug) {
        return {
          ...service,
          isMonitoringEnabled: true,
        };
      }
      return { ...service };
    });
    state.installedServices = state.allServices.filter((service) =>
      state.installedSlugs.includes(service.slug)
    );
    state.availableServices = state.allServices.filter(
      (service) => !state.installedSlugs.includes(service.slug)
    );

    state.isMonitoringEnabledForAll =
      state.installedServices.length === 0
        ? false
        : state.installedServices.every(
            (service) => service.isMonitoringEnabled
          );
  },
  [SET_TOGGLE_MONITORING](state, data) {
    if (data.serviceSlug === 'all') {
      state.allServices = state.allServices.map((service) => ({
        ...service,
        isMonitoringEnabled: data.toggleState,
      }));
    } else {
      state.allServices = state.allServices.map((service) => {
        if (service.slug === data.serviceSlug) {
          return {
            ...service,
            isMonitoringEnabled: data.toggleState,
          };
        }
        return { ...service };
      });
    }
    state.installedServices = state.allServices.filter((service) =>
      state.installedSlugs.includes(service.slug)
    );
    state.availableServices = state.allServices.filter(
      (service) => !state.installedSlugs.includes(service.slug)
    );

    state.isMonitoringEnabledForAll =
      state.installedServices.length === 0
        ? false
        : state.installedServices.every(
            (service) => service.isMonitoringEnabled
          );
  },
  [UPDATE_SERVICE_INFO](state, data) {
    state.allServices = state.allServices.map((service) => {
      if (service.slug === data.serviceSlug) {
        return {
          ...service,
          isMonitoringEnabled: data.isMonitoringEnabled,
        };
      }
      return { ...service };
    });

    state.installedServices = state.allServices.filter((service) =>
      state.installedSlugs.includes(service.slug)
    );
    state.availableServices = state.allServices.filter(
      (service) => !state.installedSlugs.includes(service.slug)
    );

    state.isMonitoringEnabledForAll =
      state.installedServices.length === 0
        ? false
        : state.installedServices.every(
            (service) => service.isMonitoringEnabled
          );
  },
  [FILTER_SERVICES_ON_INSTALLATION_TYPE_CHANGE](state, installationType) {
    console.log('installationType', installationType);

    if (installationType === 'manual') {
      state.availableServices = state.allServices.filter(
        (service) =>
          !service.showAutoInstall &&
          !state.installedSlugs.includes(service.slug)
      );
    }

    if (installationType === 'auto') {
      state.availableServices = state.allServices.filter((service) => {
        return (
          service.showAutoInstall &&
          !state.installedSlugs.includes(service.slug)
        );
      });
    }

    if (installationType === 'all') {
      state.availableServices = state.allServices.filter(
        (service) => !state.installedSlugs.includes(service.slug)
      );
    }
  },
};

export default awsServiceMutation;
